<template>
  <NewComponentLayout>
    <template #title>
      {{ $t('newcomponent.dates.title') }}
    </template>

    <ComponentDateForm />
  </NewComponentLayout>
</template>
<script setup lang="ts">
import NewComponentLayout from '../../layouts/NewComponentLayout.vue';
import ComponentDateForm from '../../components/form/ComponentDateForm.vue'

</script>